import React, { FC, useEffect, useRef } from 'react';
import { getTags } from '../selectors';
import { useSelector } from 'react-redux';
import { ResetButton } from './ResetButton';
import { TagsExpandedModeButton } from './TagsExpandedModeButton';

export const TagsLine: FC<{ content: React.ReactNode }> = ({ content }) => {
  const tags = useSelector(getTags);
  const ref = useRef<HTMLDivElement>(null);

  // Если появились новые теги (как правило, при смене проекта), то сбрасываем скролл.
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollLeft = 0;
    }
  }, [tags]);

  return (
    <div className="al-tags-line">
      <ResetButton />
      <div className="al-tags-line__content" ref={ref}>
        {content}
      </div>
      <TagsExpandedModeButton />
    </div>
  );
};
